<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h5 v-if="supplier" class="m-0">
                  {{ supplier.name }}
                </h5>
                <p class="text-black-50">
                  Balances owing to supplier, Click # to print
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr />
                <div class="row">
                  <div class="col-md-4">
                    <label for="from">From</label>
                    <b-form-datepicker
                      id="from"
                      v-model="from"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                  <div class="col-md-4">
                    <label for="to">To</label>
                    <b-form-datepicker
                      id="to"
                      v-model="to"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                  <div class="col-md-4 d-flex">
                    <button
                      @click="getData"
                      class="btn btn-primary mt-auto mb-2"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mt-4">
              <div class="card-body p-0">
                <button class="btn btn-outline-primary" v-if="selectedBranch.id == 0">
                  BF: <strong>{{ bf }}</strong>
                </button>
                <button class="btn btn-outline-primary" v-if="selectedBranch.id == 0">
                  CL: <strong>{{ closing }}</strong>
                </button>

                <b-dropdown
                  right
                  variant="light"
                  menu-class="bg-white"
                  class="float-right ml-1"
                >
                  <template v-slot:button-content>
                    {{ selectedBranch.name }}
                  </template>

                  <b-dropdown-item v-for="branch in branches" :key="branch.id" @click="branchFilter(branch)">
                    {{ branch.name }}
                  </b-dropdown-item>
                </b-dropdown>

                <button
                  class="btn float-right"
                  :class="{
                    'btn-info': order == 'asc',
                    'btn-outline-info': order != 'asc',
                  }"
                  @click="sort('asc')"
                >
                  <i class="lni lni-arrow-up"></i>
                </button>
                <button
                  class="btn float-right"
                  :class="{
                    'btn-info': order == 'desc',
                    'btn-outline-info': order != 'desc',
                  }"
                  @click="sort('desc')"
                >
                  <i class="lni lni-arrow-down"></i>
                </button>

                <button @click="print" class="btn btn-info float-right mr-2">
                  <i class="lni lni-printer"></i> Print
                </button>

                <div class="table-responsive">
                  <table class="table table-sm mt-2">
                    <thead>
                      <tr class="bg-light">
                        <th>Date</th>
                        <th>#</th>
                        <th>Inv#</th>
                        <th>GKN</th>
                        <th>Branch</th>
                        <th>Receive</th>
                        <th>Return</th>
                        <th class="text-center" v-if="selectedBranch.id == 0">Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="b in balanceSheet" :key="b.id">
                        <td>
                          {{
                            moment(new Date(b.created_at)).format(
                              "DD MMM YY, HH:mm"
                            )
                          }}
                        </td>
                        <td>
                          <span v-if="b.pallet_movement">
                            <button
                              class="btn btn-link m-0 p-0"
                              @click="
                                printMovement(
                                  b.pallet_movement.id,
                                  b.pallet_movement.pallet_movement_number
                                )
                              "
                            >
                              <u>{{
                                b.pallet_movement.pallet_movement_number
                              }}</u>
                            </button></span
                          >
                        </td>
                        <td>{{ b.pallet_movement.invoice_number }}</td>
                        <td>{{ b.pallet_movement.gkn_number }}</td>
                        <td>
                          <span
                            class="badge"
                            :class="{
                              'badge-info': b.debit != null,
                              'badge-warning': b.credit != null,
                            }"
                          >
                            <span
                              v-if="
                                b.pallet_movement &&
                                b.pallet_movement.to_branch != null
                              "
                            >
                              {{ b.pallet_movement.to_branch.name }}
                            </span>
                            <span
                              v-if="
                                b.pallet_movement &&
                                b.pallet_movement.from_branch != null
                              "
                            >
                              {{ b.pallet_movement.from_branch.name }}
                            </span>
                          </span>
                        </td>

                        <td class="text-warning">{{ b.credit }}</td>

                        <td class="text-info">{{ b.debit }}</td>

                        <td class="font-weight-bold text-center" v-if="selectedBranch.id == 0">
                          {{ b.supplier_balance }}
                        </td>
                      </tr>
                      <tr class="bg-light">
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>

                        <th class="text-warning" ><span v-if="selectedBranch.id == 0">{{ inTotal }}</span></th>

                        <th class="text-info" ><span v-if="selectedBranch.id == 0">{{ outTotal }}</span></th>
                        <th v-if="selectedBranch.id == 0"></th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import palletRepo from "@/api/repos/palletRepo";

export default {
  props: ["id"],

  mounted() {
    this.getData();
  },

  data() {
    return {
      from: this.moment().startOf("month").format("YYYY-MM-DD"),
      to: this.moment().format("YYYY-MM-DD"),
      supplier: null,
      balanceSheet: [],
      balanceSheetFull: [],
      branches: [{ id: 0, name: "All Branches" }],
      selectedBranch: { id: 0, name: "All Branches" },
      loading: false,
      errors: null,
      submitStatus: null,
      bf: 0,
      closing: 0,
      order: "desc",
      inTotal: 0,
      outTotal: 0,
    };
  },

  methods: {
    async getData() {
      if (!this.checkRange()) {
        return false;
      }

      this.order = "desc";
      this.inTotal = 0;
      this.outTotal = 0;

      try {
        let { data } = await palletRepo.balanceSheetSupplierTransactions(
          this.from,
          this.to,
          this.id
        );
        this.supplier = data.supplier;
        this.balanceSheet = data.balance_sheet;
        this.balanceSheetFull = data.balance_sheet;
        this.branches = [{ id: 0, name: "All Branches" }]
        this.selectedBranch = { id: 0, name: "All Branches" }
        data.branches.forEach((b) => {
          this.branches.push(b);
        });

        if (this.balanceSheet.length > 0) {
          this.closing = this.balanceSheet[0].supplier_balance;
          if (this.balanceSheet[this.balanceSheet.length - 1].debit != null) {
            this.bf =
              this.balanceSheet[this.balanceSheet.length - 1].supplier_balance +
              this.balanceSheet[this.balanceSheet.length - 1].debit;
          } else {
            this.bf =
              this.balanceSheet[this.balanceSheet.length - 1].supplier_balance -
              this.balanceSheet[this.balanceSheet.length - 1].credit;
          }
        }
        this.balanceSheet.forEach((x) => {
          if (x.debit != null) {
            this.outTotal += x.debit;
          } else {
            this.inTotal += x.credit;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    sort(order) {
      this.order = order;

      if (order == "asc") {
        this.balanceSheet.sort((a, b) => {
          if (a.id > b.id) return 1;
          if (a.id < b.id) return -1;
          return 0;
        });
      } else {
        this.balanceSheet.sort((a, b) => {
          if (a.id < b.id) return 1;
          if (a.id > b.id) return -1;
          return 0;
        });
      }
    },
    async print() {
      if (!this.checkRange()) {
        return false;
      }

      this.loading = true;

      try {
        let response = await palletRepo.balanceSheetSupplierTransactionsPrint(
          this.from,
          this.to,
          this.id,
          this.selectedBranch.id
        );
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `pallet_supplier_transactions_balance_sheet.pdf`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    checkRange() {
      //from is not greate
      if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), "days") > 366) {
        this.$root.$bvToast.toast("Range can not be greater than 1 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      return true;
    },
    async printMovement(id, number) {
      this.loading = true;

      try {
        let response = await palletRepo.movementPrint(id);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `pallet_movement_${number}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    branchFilter(branch){
        this.selectedBranch = branch

        if(branch.id == 0){
            this.balanceSheet = this.balanceSheetFull
        }else{
            this.balanceSheet = this.balanceSheetFull.filter(x =>(x.pallet_movement.to_branch_id == branch.id || x.pallet_movement.from_branch_id == branch.id))
        }

    }
  },
};
</script>

